import { Component, EventEmitter, Output, ViewEncapsulation, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MessageTemplateService, CreateTemplateRequest, MessageTemplate } from '../../core/services/message-template.service';
import { SessionService } from '../../core/session.service';

@Component({
  selector: 'app-news-template-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './news-template-modal.component.html',
  styleUrls: ['./news-template-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class NewsTemplateModalComponent implements OnInit, OnDestroy {

  ngOnInit(): void {
    document.body.classList.add('modal-open');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('modal-open');
  }

  @Output() close = new EventEmitter<void>();
  @Output() created = new EventEmitter<MessageTemplate>();

  private fb = inject(FormBuilder);
  private templateService = inject(MessageTemplateService);
  private session = inject(SessionService);
  private translate = inject(TranslateService);

  loading = false;
  errorMsg = '';

  form = this.fb.nonNullable.group({
    name: ['', Validators.required],
    content: ['', Validators.required],
  });

  submit(): void {
    if (this.loading || this.form.invalid) return;
    
    const selectedId = this.session.selectedId();
    const establishment = this.session.establishments().find(e => e.id === selectedId);
    if (!establishment?.org_id) {
      this.errorMsg = this.translate.instant('componentsWizard.newsTemplate.errorOrgNotFound');
      return;
    }

    this.loading = true;
    this.errorMsg = '';

    const raw = this.form.getRawValue();
    const payload: CreateTemplateRequest = {
      organisationId: establishment.org_id,
      name: raw.name.trim(),
      content: raw.content.trim(),
      type: 'NEWS_FEED'
    };

    this.templateService.createTemplate(payload).subscribe({
      next: (template: MessageTemplate) => {
        this.created.emit(template);
        this.close.emit();
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.errorMsg = err?.error?.message || this.translate.instant('componentsWizard.newsTemplate.errorDefault');
      },
    });
  }

  onClose(): void {
    if (!this.loading) this.close.emit();
  }
}